<template>
    <div class="telephone-wrapper">
        <div class="flex justify-between mb-3 relative">
            <div v-if="label || subtext || v.errors.length || errorMessage">
                <label class="label" v-if="label" :for="name">
                    {{ label }}
                    <span v-if="rules.includes('optional')" class="opacity-40 ml-2">(Optional)</span>
                </label>
            </div>
            <div v-if="hint">
                <HintComponent :hint="hint" />
            </div>
        </div>
        <div class="telephone-container flex items-center">
            <div>
                <ValidationProvider :rules="rules" v-slot="v">
                    <v-select
                        v-model="telephoneCodeValue"
                        :reduce="reduce"
                        placeholder="+44"
                        :options="options"
                        :class="[v.errors.length || errorMessage ? 'has-errors' : '']"
                        :clearable="false"
                        :filter="filterDialCodes"
                        label="international_dialling_code"
                    >
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes" class="icon-chevron cursor-pointer"></span>
                        </template>
                        <template #option="option">
                            <div :class="[!option.is_visible ? 'opacity-20' : '']">
                                <span class="mr-3">
                                    <img
                                        style="width: 24px; height: auto"
                                        :src="global.app.url + 'images/countries/' + option.iso_code_2 + '.svg'"
                                    />
                                </span>
                                <span>{{ option.name }} ({{ option.international_dialling_code }})</span>
                            </div>
                        </template>
                        <template #selected-option="option">
                            <span class="mr-2">
                                <img
                                    style="width: 24px; height: auto"
                                    :src="global.app.url + 'images/countries/' + option.iso_code_2 + '.svg'"
                                />
                            </span>
                            <span>
                                {{ option.international_dialling_code }}
                            </span>
                        </template>
                    </v-select>
                    <p v-if="v.errors.length" class="!opacity-100 subtext text-error !pt-0 ml-4 pb-3">
                        {{ v.errors[0] }}
                    </p>
                </ValidationProvider>
            </div>
            <div class="grow">
                <ValidationProvider :rules="rules" v-slot="v">
                    <input
                        v-model="telephoneNumberValue"
                        :name="name"
                        type="tel"
                        :placeholder="placeholder"
                        class="w-full border-0"
                        :class="[v.errors.length || errorMessage ? 'has-errors' : '']"
                    />
                    <p v-if="v.errors.length" class="!opacity-100 subtext text-error !pt-0 ml-4 pb-3">
                        {{ v.errors[0] }}
                    </p>
                </ValidationProvider>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ValidationProvider } from "vee-validate";
import HintComponent from "@components/misc/HintComponent";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    name: "TelephoneComponent",
    props: {
        name: { type: String, default: "" }, // "Name" prop for naming the input
        telephone_no: { default: "" }, // "Value" prop for setting an initial value for the input
        telephone_code: { default: "" },
        label: { type: String, default: "" }, // Label used for the input
        options: { type: Array, default: "" }, // array of options
        placeholder: { type: String, default: "" }, // The input's placeholder text
        hint: { type: String, default: "" }, // For the little "?" that appears with a hint for the specific input field
        rules: { type: String, default: "required" }, // The validation rules set on the input. See VeeValidate for available rules
        error: { type: String, default: "" }, // Used to set a specific error from the response from the backend/API
        reduce: { default: (option) => option }, // Used to calculate what values are returned from what option is selected
    },
    components: {
        ValidationProvider,
        HintComponent,
        vSelect,
    },
    computed: {
        ...mapGetters(["global"]),
    },
    data: function () {
        return {
            telephoneNumberValue: this.telephone_no,
            telephoneCodeValue: this.telephone_code,
            errorMessage: this.error,
            hasChangedTelephoneNumber: false,
            hasChangedTelephoneCode: false
        };
    },
    methods: {
        filterDialCodes(options, search) {
            // Helper function that is used as the filter when someone searches for an international dialling code
            return this.options.filter((option) => {
                let name = option.name;
                let dialCode = option.international_dialling_code;
                if (typeof name === "number") {
                    name = name.toString();
                }
                return (
                    (name || "").toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1 ||
                    (dialCode || "").toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1
                ); // Show results for if the user inputs either a country name or the international dialling code
            });
        },
    },
    watch: {
        telephoneNumberValue(value) {
            this.telephoneNumberValue = value;
            this.$emit("telephone_no", this.telephoneNumberValue);
            this.$emit("change");
        },
        telephoneCodeValue(value) {
            this.telephoneCodeValue = value;
            this.$emit("telephone_code", this.telephoneCodeValue);
            this.$emit("change");
        },
        telephone_no(value) {
            if (!this.hasChangedTelephoneNumber) {
                this.telephoneNumberValue = value;
                this.hasChangedTelephoneNumber = true;
            }
        },
        telephone_code(value) {
            if (!this.hasChangedTelephoneCode) {
                this.telephoneCodeValue = value;
                this.hasChangedTelephoneCode = true;
            }
        },
        error() {
            this.errorMessage = this.error;
        },
    },
};
</script>
